import { AREA_VALUES } from "../../shared/lead";
import { useI18n } from "../i18n/I18nProvider";
import { IconChevron } from "./icons";

/** The five area bands. Nothing is preselected: the answer is optional. */
export function AreaChooser({
  value,
  onChange,
  invalid,
  errorId,
  error,
}: {
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
  errorId: string;
  error: string | null;
}) {
  const { copy } = useI18n();
  const t = copy.form;

  return (
    <div className="flex flex-col gap-[9px]">
      <div className="lg:hidden">
        <label htmlFor="area" className="text-[13px] font-semibold leading-[24px] text-navy">
          {t.area}
        </label>
        <div className="relative mt-[7px]">
          <select
            id="area"
            name="area"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            aria-invalid={invalid || undefined}
            aria-describedby={invalid ? errorId : undefined}
            className="h-[50px] w-full appearance-none rounded-xl border border-line bg-white px-4 pe-10 text-[13px] leading-[24px] text-ink"
          >
            <option value="">{t.areaPlaceholder}</option>
            {AREA_VALUES.map((area) => (
              <option key={area} value={area}>
                {copy.area[area]}
              </option>
            ))}
          </select>
          <span
            aria-hidden="true"
            className="pointer-events-none absolute end-4 top-1/2 flex -translate-y-1/2 items-center text-[16px] text-[#8f909e]"
          >
            <IconChevron />
          </span>
        </div>
      </div>
      <div className="hidden lg:block">
        <fieldset className="m-0 p-0">
          <legend className="p-0 text-[13px] font-semibold leading-[24px] text-navy">
            {t.area}
          </legend>
          <div className="mt-2 flex flex-wrap gap-2">
            {AREA_VALUES.map((area) => {
              const selected = value === area;
              return (
                <button
                  key={area}
                  type="button"
                  data-area={area}
                  aria-pressed={selected}
                  onClick={() => onChange(selected ? "" : area)}
                  className={`h-[41px] rounded-full border px-[13px] text-[11px] font-medium leading-[21px] transition-colors ${
                    selected
                      ? "border-purple bg-tint text-ink"
                      : "border-line bg-surface text-ink hover:border-purple"
                  }`}
                >
                  {copy.area[area]}
                </button>
              );
            })}
          </div>
        </fieldset>
      </div>
      {invalid && error ? (
        <p id={errorId} className="text-[11px] font-semibold text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
